
import * as icons from '@mdi/js'

export default {
  props: {
    items: {
      type: Array,
      required: true
    }
  },
  methods: {
    getIcon (item) {
      // eslint-disable-next-line
      return icons[item.icon] ?? "$checkedNew";
    }
  }
}
